import type { IconSvgObject } from './types';

const MusicNote04Icon: IconSvgObject = [
  ["circle", { cx: "8", cy: "17", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 17V3C14.3333 3 19.2 4.4 20 10C19 9 15 7 12 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MusicNote04Icon;
